import React from 'react'
import { connect } from 'react-redux'

import SuitesStaff from '../../containers/Staff'
import Layout from '../../components/Layout'

export const Staff = ({ history }) => {
  return (
    <Layout isSidebar={true} title='Staff'>
      <SuitesStaff history={history} />
    </Layout>
  )
}

export default connect(null, null)(Staff)
